<template>
  <div class="bottom">
    <div class="bottom-con">
      <a class="fix" href="http://www.eicchannel.com">
        <img src="@/assets/images/bottom_bg.png" alt="" /> 
        <!-- <dt>
          <a href="http://www.eicchannel.com" target="_blank">
            <img src="@/assets/images/bottom_logo.png" alt="启德课堂" />
          </a>
        </dt>
        <dd>
          更多留学直播与视频讲座尽在启德课堂
          <br />专注于留学知识分享的视频平台
          <br />
          <a href="http://m.eicchannel.com">www.eicchannel.com</a>
        </dd> -->
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Bottom",
  components: {},
};
</script>

<style scoped lang="less">
.bottom {
    width: 100%;
    height: 3.36rem;
    //margin-top: -3rem;
}
.bottom-con {
  // border-top: 0.02rem solid #aa4f4e;
  width: 6.66rem;
  position: relative;
  //padding-top: 3rem;
  margin: 0 auto;
}
.bottom-con dl dt {
  width: 1.2rem;
  height: 0.9rem;
  float: left;
  margin-right: 0.4rem;
  padding-top: 0.1rem;
}
.bottom-con dl dd {
  font-size: 14px;
  color: #fff;
  font-size: 0.24rem;
}
.bottom-con dl dd a {
  color: #fff;
}
.bottom-con dl dd a:hover {
  text-decoration: underline;
}
.bottom .fix {
  width: 0.75rem;
  height: 0.85rem;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>